import { TimelineRefundEvent } from '@/components/Timeline/types';
import { TeammateAvatar } from '@/components/TeamAvatar';
import { ActorAvatar } from '@/components/Timeline/TimelineItems/ActorAvatar';
import { DateTimeTooltip } from '@/components/Timeline/TimelineItems/DateTimeTooltip';
import { TimelineCard } from '@/components/Timeline/TimelineItems/TimelineCard';
import { useProviderDirectory } from '@/hooks/useProviderDirectory';
import { Group, Text } from '@mantine/core';
import { formatHumanName, resolveId } from '@medplum/core';

/**
 * One step of a refund request (BAR-3052): requested, approved, issued.
 * Append-only like the payment cards. The body is the reason and note, or
 * Finance's approval note; an issued card is header-only.
 */
export function RefundEventCard({ item }: { item: TimelineRefundEvent }) {
  const { practitioners } = useProviderDirectory();
  const recordedById = item.recordedBy ? resolveId({ reference: item.recordedBy }) : undefined;
  const recorder = recordedById ? practitioners.find((practitioner) => practitioner.id === recordedById) : undefined;
  const recordedByName = recorder?.name?.[0] && formatHumanName(recorder.name[0]);

  return (
    <TimelineCard
      header={
        <Group justify="space-between" align="center" wrap="nowrap">
          <Text size="md" fw={600}>
            {item.title}
          </Text>
          <Group gap="md" align="center" wrap="nowrap">
            {item.recordedBy ? (
              <TeammateAvatar
                practitioner={{ reference: item.recordedBy }}
                label={recordedByName ? `Recorded by ${recordedByName}` : undefined}
              />
            ) : (
              <ActorAvatar variant="system" label="Linked automatically when the refund arrived" />
            )}
            <DateTimeTooltip date={item.timestamp} />
          </Group>
        </Group>
      }
    >
      {item.note ? (
        <Text size="sm" style={{ whiteSpace: 'pre-wrap' }}>
          {item.note}
        </Text>
      ) : null}
    </TimelineCard>
  );
}
